"use client";

import React from "react";
import { Monitor, Users, Leaf, Trash2, ChevronRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Jednostavno upravljanje",
  description: "Iskoristite prednosti intuitivne platforme prilagođene korisniku bez potrebe za posebnom infrastrukturom.",
  icon: Monitor
}, {
  title: "Alat za obuku",
  description: "Uštedite vrijeme koristeći aplikaciju kao alat za obuku vaših zaštitara i nadzornika na terenu.",
  icon: Users
}, {
  title: "Bez papira",
  description: "Prebacite se s papirnatog poslovanja na digitalnu platformu, smanjite otpad i pomozite okolišu.",
  icon: Leaf
}];
export default function OurExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222473" id="digitalna-transformacija" className="bg-background py-24 w-full overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`mb-16 md:mb-20 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default font-bold text-3xl md:text-5xl text-foreground tracking-tight mb-4">
            Diferencirajte svoju <span className="text-primary">uslužnu tvrtku</span>
          </h2>
          <div className="w-20 h-1.5 bg-primary rounded-lg"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
          const Icon = service.icon;
          const delay = index * 150;
          return <div key={index} data-index={index} className={`transition-all duration-700 ease-out fill-mode-both ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${delay}ms`
          }}>
                <Card className="relative h-full overflow-hidden border-border bg-card shadow-sm hover:shadow-md transition-all duration-300 group/card rounded-xl">
                  <CardContent className="p-8 flex flex-col h-full text-center">
                    
                    {}
                    <div className="relative mb-8 h-20 flex items-center justify-center">
                      <div className="relative z-10 bg-muted size-20 rounded-lg flex items-center justify-center transition-transform duration-300 group-hover/card:scale-110">
                        <Icon className="size-10 text-primary" />
                      </div>
                    </div>

                    {}
                    <div className="flex-grow">
                      <h3 className="font-default font-semibold text-2xl mb-4 tracking-wide text-foreground">
                        {service.title}
                      </h3>
                      <p className="text-muted-foreground text-lg leading-relaxed mb-6">
                        {service.description}
                      </p>
                    </div>

                    {}
                    <div className="mt-auto pt-4 border-t border-border/40">
                      <Button variant="link" asChild className="p-0 h-auto text-primary font-semibold group/link hover:no-underline relative pr-5">
                        <Link to="/HomePage">
                          Saznajte više
                          <ChevronRight className="size-4 absolute right-0 opacity-0 -translate-x-2 transition-all duration-300 group-hover/link:opacity-100 group-hover/link:translate-x-0" />
                        </Link>
                      </Button>
                    </div>

                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        <div className="mt-16 flex justify-center">
          <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-6 text-lg font-semibold rounded-xl shadow-lg transition-all duration-300">
            <Link to="/FeaturesPage">Saznajte više o prednostima</Link>
          </Button>
        </div>
      </div>
    </section>;
}